export enum ETransmittalPurposeCodeConst {
  SE = '-SE', // For Placeholder
  A = 'A', // Approved / For Approval / Certification
  C = 'C', // For Construction
  D = 'D', // For Draft
  I = 'I', // For Information
  O = 'O', // Other
  P = 'P', // For Pricing
  R = 'R', // For Review / Comment
  S = 'S', // For Onward Submission
  Z = 'Z', // Approved by Authorities
}
